import InstagramBlock from './InstagramBlock';

export default InstagramBlock;
